//css
import './styles/main.scss';

//js
import './scripts/main.js'